export default __webpack_public_path__ + "static/media/(24).7d441d12.jpeg";